import React, { ReactNode } from "react";
import { Typography, Button, ButtonProps } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

interface DSUploadButtonProps extends Omit<ButtonProps, "children"> {
  children?: ReactNode;
  text?: string;
}

const DSUploadButton: React.FC<DSUploadButtonProps> = ({
  text = "Upload File",
  children,
  sx,
  ...props
}) => {
  return (
    <Button
      component="span"
      sx={{
        borderStyle: "dashed",
        borderWidth: 2,
        py: 2,
        px: 3,
        borderRadius: 2,
        width: "100%",
        border: "2px dashed",
        borderColor: "divider",
        color: "text.primary",
        backgroundColor: "action.hover",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          backgroundColor: "action.selected",
          borderColor: "primary.main",
          transform: "translateY(-1px)",
        },
        ...sx,
      }}
      {...props}
    >
      <CloudUploadIcon />
      {children || <Typography>{text}</Typography>}
    </Button>
  );
};

export default DSUploadButton;
